import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-16 px-4 bg-[#FFF0F5]" data-id="element-147">
      {' '}
      {/* Soft pink pastel */}
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-pink-100" data-id="element-149">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-150">
            Si tu hijo se frustra con la lectura… dejame hacerte una pregunta
            honesta:
          </h2>

          <p className="text-xl text-gray-700 mb-8 font-medium" data-id="element-151">
            ¿Te pasa que la lectura termina siendo pelea, cansancio o ganas de
            llorar? No porque tu hijo "no pueda". No porque vos estés haciendo
            algo mal. Sino porque{' '}
            <span className="bg-yellow-200 font-bold px-1" data-id="element-152">
              a la mayoría nadie le dio un método claro
            </span>{' '}
            para avanzar sin trabarse.
          </p>

          <p className="text-xl text-gray-700 mb-10 font-medium" data-id="element-153">
            Y lo peor no es el ejercicio. Lo peor es esa sensación de:{' '}
            <span className="italic font-bold text-red-600" data-id="element-154">
              "Siento que se está quedando atrás… y no sé cómo ayudar sin
              presionarlo."
            </span>
          </p>

          <div className="border-t-2 border-pink-100 pt-10" data-id="element-155">
            <h3 className="text-3xl font-black text-gray-900 mb-8 text-center uppercase tracking-tight" data-id="element-156">
              El problema que nadie dice en voz alta
            </h3>

            <p className="text-lg text-gray-600 mb-6 text-center" data-id="element-157">
              Si estás acá, probablemente te suene familiar:
            </p>

            <ul className="space-y-4 text-lg font-medium text-gray-800" data-id="element-158">
              <li className="flex items-start gap-3" data-id="element-159">
                <span className="text-red-500 mt-1" data-id="element-160">❌</span>
                <span data-id="element-161">Tu hijo lee lento y con pausas</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-162">
                <span className="text-red-500 mt-1" data-id="element-163">❌</span>
                <span data-id="element-164">Se traba en palabras simples</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-165">
                <span className="text-red-500 mt-1" data-id="element-166">❌</span>
                <span data-id="element-167">Evita leer en voz alta por miedo a equivocarse</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-168">
                <span className="text-red-500 mt-1" data-id="element-169">❌</span>
                <span data-id="element-170">
                  Lee… pero no comprende (no puede explicar lo que leyó)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-171">
                <span className="text-red-500 mt-1" data-id="element-172">❌</span>
                <span data-id="element-173">
                  La escritura sale desordenada, con faltas o sin estructura
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-174">
                <span className="text-red-500 mt-1" data-id="element-175">❌</span>
                <span data-id="element-176">
                  Vos buscás actividades en mil lados (y terminás con PDFs
                  perdidos)
                </span>
              </li>
            </ul>

            <div className="mt-8 p-6 bg-red-50 rounded-xl border border-red-100" data-id="element-177">
              <p className="text-xl font-bold text-red-800 text-center" data-id="element-178">
                Y cada semana parece lo mismo: improvisar, probar "algo",
                frustrarse y volver a empezar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}